import { createUseStyles } from 'react-jss';

const styles = createUseStyles({
  flag:{
    width: 20,
    height: 20,
    borderRadius: "50%",
    overflow: "hidden",
    flexShrink: 0,
  },
});

export default styles;